import InputMask from 'react-input-mask'
import Input from '../Input'
import { Props } from './interfaces'

export const MaskedInput = (props: Props) => {
  return (
    <InputMask {...props} maskChar={null}>
      {(inputProps) => <Input {...inputProps} />}
    </InputMask>
  )
}

export default MaskedInput
